import { Type } from "@sinclair/typebox";
import { MediaContent, MessageContent } from "./messageContent";
import { Recipient } from "./recipient";
import { NullableIdLike, NullableString } from "../../../utils/typeboxTypes";
export const BaseMessage = Type.Object({
    /**
     * The Deskpro unique ID of the message.
     */
    id: Type.String(),
    /**
     * The external unique ID of the message.
     */
    external_id: Type.Optional(NullableIdLike),
    /**
     * ID of the conversation the message belongs to.
     */
    conversation_id: Type.String(),
    /**
     * The ISO date time the message was created.
     */
    created_at: Type.String(),
    /**
     * The ISO date time the message failed to be sent.
     */
    failed_at: Type.Optional(NullableString),
    /**
     * The reason for the message failing to be sent.
     */
    failed_reason: Type.Optional(Type.String()),
    /**
     * The content of the message.
     */
    content: MessageContent,
    /**
     * Optional media that is attached to the message.
     */
    media: Type.Optional(Type.Array(MediaContent)),
    /**
     * The author of the message.
     */
    author: Recipient,
    /**
     * The recipients of the message.
     */
    recipients: Type.Array(Recipient),
    /**
     * The upload session id used to upload associated files
     * that requires finalisation to ensure the files do not
     * get garbage collected
     */
    upload_session_id: Type.Optional(Type.String()),
    /**
     * The files associated with the message that have been
     * uploaded to the servers file storage API.
     */
    files: Type.Optional(Type.Array(Type.String({ format: "uuid" }))),
}, {
    title: "BaseMessage",
});
export const InboundMessage = Type.Composite([
    BaseMessage,
    Type.Object({
        type: Type.Literal("inbound"),
    }, {
        title: "InboundMessage",
    }),
]);
export const OutboundMessage = Type.Composite([
    BaseMessage,
    Type.Object({
        type: Type.Literal("outbound"),
    }, {
        title: "OutboundMessage",
    }),
]);
export const MessageSchema = Type.Union([InboundMessage, OutboundMessage]);
